import axios from 'axios';

const isLocal = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
const baseURL = isLocal ? '/api' : process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      console.warn('⚠️ Session expirée ou non authentifiée');
    }

    if (status === 403) {
      console.warn('⛔ Accès refusé');
    }

    return Promise.reject(error);
  }
);

export const getMessages = () => api.get('/messages');
export const sendMessage = (data) => api.post('/messages', data);
export const hideMessage = (id, visible = false) =>
  api.patch(`/messages/${id}/visibility`, { visible });

export const getDepartements = () => api.get('/departements');
export const getUsersSimple = () => api.get('/users/users-simple');
export const getOuvriers = () => api.get('/ouvriers');

export const logoutUser = () => api.post('/auth/logout');

export default api;